import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttList } from './SttList';
import { SttLabelWeekdays } from '../all';

type Slot = {
    weekdays: number[];
    timeini: string;
    timeend: string;
};

type Props = {
    slots: Slot[];
    onAdd?: () => void;
    onSelect?: (slot: Slot) => void;
};

export function SttBookingScheduleSlotList({
    slots,
    onAdd,
    onSelect,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    function select(slot: Slot) {
        if (onSelect && onSelect.constructor === Function) {
            onSelect(slot);
        }
    }

    return (
        <SttList
            title={t('TimeSlot')}
            onAdd={onAdd}
            onSelect={select}
            data={
                slots &&
                slots.map((slot: any) => ({
                    avatar: null,
                    caption: (
                        <Box display="flex" justifyContent="space-between">
                            <SttLabelWeekdays weekdays={slot.weekdays} />
                            <Box
                                ml={1}
                            >{`${slot.timeini} - ${slot.timeend}`}</Box>
                        </Box>
                    ),
                    objToSelect: slot,
                }))
            }
        />
    );
}
